import React, { useEffect, useState, useRef } from 'react';
import { Splide, SplideSlide } from '@splidejs/react-splide';

const ImageSlider = ({ images, title, enableThumbnailCarousel, className }) => {
    if (!images || images.length === 0)
        return;

    const mainSliderRef = useRef(null);
    const thumbnailSliderRef = useRef(null);

    const targetElementRef = useRef(null);
    const [progressFill, setProgressFill] = useState();
    const [currentImageNumber, setCurrentImageNumber] = useState(0);
    const [zoomImage, setZoomImage] = useState();
    const applyProgressBarWidthAndImageNumber = (slide) => {
        const index = slide?.index ? slide.index : 0;
        const elementWidth = 100 / images.length;
        setProgressFill({ width: elementWidth + "%", left: (index * elementWidth) + "%" });
        setCurrentImageNumber(index + 1);
    }
    useEffect(() => {
        applyProgressBarWidthAndImageNumber();
            if (mainSliderRef.current && thumbnailSliderRef.current) {
                mainSliderRef.current.sync(thumbnailSliderRef.current.splide);
            }
    }, []);

    useEffect(() => {
        const zoomImageDiv = targetElementRef.current;
        if (zoomImage) {
            if (zoomImageDiv.scrollWidth > 0 && zoomImageDiv.scrollHeight > 0) {
                zoomImageDiv.scrollLeft = zoomImageDiv.scrollWidth / 2 - window.innerWidth / 2;
                zoomImageDiv.scrollTop = zoomImageDiv.scrollHeight / 2 - window.innerHeight / 2;
            }
            document.body.classList.add('overflow-hidden');
        } else {
            document.body.classList.remove('overflow-hidden');
        }
    }, [zoomImage]);
    return <div className={`imageSlider ${className} ${enableThumbnailCarousel ? 'imageSlider--thumbnailCarousel' : ''}`}>
        {title && <p className='m-0 heading5'>{title}</p>}
        <div className="wrapper">
            <Splide className='splide--main' ref={mainSliderRef} options={{ pagination: false, type: images.length > 1 ? 'loop' : 'slide', arrows: images.length > 1 }} onMoved={applyProgressBarWidthAndImageNumber}>
                {images.map((image, index) => {
                    return <SplideSlide onClick={(e) => { setZoomImage({ src: e.target.src, alt: e.target.alt }) }} key={index}>
                        <img src={image.src} alt={image.alt} />
                    </SplideSlide>
                })}
            </Splide>
            {images.length > 1 && <><div className="zoomText p-lg-4 paragraph--xs">Click to zoom</div>
                <div className="imageSlider__count paragraph--xs"><span className="sr-only">Current image number</span>{currentImageNumber.toString().padStart(2, '0')}/{images.length.toString().padStart(2, '0')}</div>
                <div className="progress-container"><div className="progress-bar"><div style={progressFill} className="progress-fill"></div></div></div></>}
        </div>

        {zoomImage && <div ref={targetElementRef} className='imageSlider__zoom p-lg-10'>
            <button onClick={() => setZoomImage(null)} className='btn zoom__close d-none d-lg-block'><i className='le-icon-x'></i></button>
            <img onClick={() => setZoomImage(null)} src={zoomImage.src} alt={zoomImage.alt} />
        </div>}

        {images.length > 1 && <div className="thumbnailCarousel">
            <Splide
                ref={thumbnailSliderRef}
                className='splide--thumbnail'
                options={{
                    isNavigation: true,
                    gap: 4,
                    focus: 'center',
                    pagination: false,
                    arrows: false,
                    fixedWidth: "calc(100% / 4.5",
                }}
            >
                {images.map((image, index) => (
                    <SplideSlide key={index}>
                        <img src={image.src} alt={image.alt} />
                    </SplideSlide>
                ))}
            </Splide>
        </div>}
    </div>;
}

export default ImageSlider;